<!--
  @AUthor Sai Naveen Somaraju
  This is the form for the validation configuration used for 
  1) saving
  2) editing

  it has reference from validationconfiguration-popup component
  @Date: 02/11/2023
-->
<div class="mainContent">
  <div style="height: 7vh;">
    <div>
      <label i18n="@@spmsUserReg" class="textColour" [ngStyle]="{'border-color': backgroundColorButton}">
        Pre-Validation Configuration
      </label>
      <span class="example-spacer"></span>
    </div>
  </div>

  <div>
    <form novalidate [formGroup]="FormValid" style="width: 100%;">
      <div class="row" style="margin-top: 10px;padding:1px;">
        <div class="col-lg">
          <mat-checkbox formControlName="status"><b>Status</b></mat-checkbox>
        </div>
      </div>
      
      <div class="row" style="margin-top: 10px;padding:1px;" *ngIf="FormValid.get('status').value === false">
        <div class="col-lg">
          <span  style="color: orange;"> Note: All fields are disabled</span>
        </div>
      </div>

      <div class="row" style="margin-top: 10px;">
        <div class="col-lg">
          <mat-form-field appearance="outline">
            <mat-label>Property Name</mat-label>
            <input [readonly]="FormValid.get('status').value === false" matInput type="text"
              formControlName="propertyname" [(ngModel)]="prevalidateconfiguration.propertyname" required />
            <mat-error style="font-size: 15px; color: red;"
              *ngIf="FormValid.get('propertyname').hasError('required') && (FormValid.get('propertyname').dirty || FormValid.get('propertyname').touched)">
              propertyname is required.
            </mat-error>
          </mat-form-field>


        </div>
      </div>
      <div class="row" style="margin-top: 10px;">
        <div class="col-lg">
          <mat-form-field appearance="outline">
            <mat-label>Property Type</mat-label>
            <mat-select appearance="outline" formControlName="propertytype"
              [(ngModel)]="prevalidateconfiguration.propertytype" placeholder="Select property type"
              [disabled]="FormValid.get('status').value === false" name="propertytype">
              <mat-option *ngFor="let item of propertyTypeList" [value]="item.lookupcode">{{item.lookupcode}}</mat-option>
            </mat-select>
            <mat-error style="font-size: 15px; color: red;"
              *ngIf="FormValid.get('propertytype').hasError('required') && (FormValid.get('propertytype').dirty || FormValid.get('propertytype').touched)">
              propertytype is required.
            </mat-error>
          </mat-form-field>



        </div>
      </div>
      <div class="row" style="margin-top: 10px;">
        <div class="col-lg">
          <mat-form-field appearance="outline">
            <mat-label>Expected Value</mat-label>
            <input [readonly]="FormValid.get('status').value === false" matInput type="text"
              formControlName="Expected Value" [(ngModel)]="prevalidateconfiguration.expectedvalue" required />
            <mat-error style="font-size: 15px; color: red;"
              *ngIf="FormValid.get('expectedvalue').hasError('required') && (FormValid.get('expectedvalue').dirty || FormValid.get('expectedvalue').touched)">
              expectedvalue is required.
            </mat-error>
          </mat-form-field>

        </div>
      </div>


      <div class="row" style="margin-top: 10px;">
        <div class="col-lg">
          <mat-form-field appearance="outline">
            <mat-label>Validation Logic</mat-label>
            <input [readonly]="FormValid.get('status').value === false" matInput type="text"
              formControlName="validationlogic" [(ngModel)]="prevalidateconfiguration.validationlogic" required />
            <mat-error style="font-size: 15px; color: red;"
              *ngIf="FormValid.get('validationlogic').hasError('required') && (FormValid.get('validationlogic').dirty || FormValid.get('validationlogic').touched)">
              validationlogic is required.
            </mat-error>
          </mat-form-field>

        </div>
      </div>
      <div class="row" style="margin-top: 10px;">
        <div class="col-lg">
          <mat-form-field appearance="outline">
            <mat-label>Retrieval Type</mat-label>
            <mat-select appearance="outline" formControlName="retrievaltype"
              [(ngModel)]="prevalidateconfiguration.retrievaltype" placeholder="Select retrieval type"
              [disabled]="FormValid.get('status').value === false" name="retrievaltype">
              <mat-option *ngFor="let item of retrievalTypeOptions" [value]="item.lookupcode">{{item.lookupcode}}</mat-option>
            </mat-select>
            <mat-error style="font-size: 15px; color: red;"
              *ngIf="FormValid.get('retrievaltype').hasError('required') && (FormValid.get('retrievaltype').dirty || FormValid.get('retrievaltype').touched)">
              retrievaltype is required.
            </mat-error>
          </mat-form-field>


        </div>
      </div>
    </form>
  </div>

  <mat-dialog-actions style="display: flex; justify-content: flex-end; margin-top: auto;">

    <button _ngcontent-qoy-c414="" (click)="updateData()" title="persist property"
      class="pauseMgrButton popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
      style="padding:0.6rem 1.6rem 0.5rem 1.6rem;margin-top: 20px; background-color: rgb(189, 172, 66);">{{buttonName}}</button>

    <button _ngcontent-qoy-c414="" (click)="close()" title="close this popup window"
      class="pauseMgrButton popup gridColour btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
      [style.border-color]="backgroundColorButton"
      style="padding:0.6rem 1.6rem 0.5rem;margin-top: 20px;background-color: white !important;color: black;border-width: 1px;border-style: solid;">Cancel
    </button>

  </mat-dialog-actions>

</div>